// KontaktSprung.tsx — Klick auf den Namen in einer Beziehungsliste springt zur
// Akte des Kontakts (User 28.09.2026: Haushalt, weitere Beziehungen, Leitung/
// Gesellschafter, Verantwortung, Mensch im Unternehmen, Verbindungen zu Firmen,
// Arbeitgeber …).
//
// Nur die Kontaktakte stellt den Sprung bereit (`KontaktSprungContext`) — in
// der Neuanlage gibt es keine Verlassen-Warnung, ein Klick auf einen Namen
// würfe dort die halbe Eingabe weg. Die Akte navigiert per Router; ihre
// Verlassen-Warnung (`useVerlassenSperre`) fragt bei Ungespeichertem nach.
//
// Kein <a>/<button>: Der Name muss auch in der gesperrten Akte
// (`<fieldset disabled>`) klickbar bleiben — wie `AnsichtsKnopf`.

import * as React from "react";

/** Springt zur Akte des Kontakts `contactId`; `null` = kein Sprung (Neuanlage). */
export const KontaktSprungContext = React.createContext<((contactId: number) => void) | null>(null);

const STIL: React.CSSProperties = {
  cursor: "pointer",
  textDecoration: "underline",
  textDecorationColor: "rgba(125, 33, 105, 0.35)",
  textUnderlineOffset: "3px",
};

/**
 * Der Name als Sprung zur Akte — nur mit `contactId` und nur in der Akte.
 * Sonst bleibt es beim bloßen Text.
 */
export function KontaktName({
  contactId,
  children,
  className,
}: {
  contactId?: number | null;
  children: React.ReactNode;
  className?: string;
}) {
  const springe = React.useContext(KontaktSprungContext);
  const id = Number(contactId);
  if (!springe || !Number.isInteger(id) || id <= 0) {
    return <span className={className}>{children}</span>;
  }
  const los = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    springe(id);
  };
  return (
    <span
      role="link"
      tabIndex={0}
      title="Akte öffnen"
      className={className}
      style={STIL}
      onClick={los}
      onKeyDown={(e) => {
        if (e.key === "Enter") los(e);
      }}
    >
      {children}
    </span>
  );
}
